import { Stack, Text } from '@fluentui/react';

import { openMiniEditor } from '../Forms/MiniEditor';
import ProductList from '../Forms/New/Components/ProductList';
import ShipmentSection from '../Forms/New/Components/ShipmentSection';

export default (formId: string, onClosed?: () => void) => {
  openMiniEditor({
    formId,
    onClosed,
    title: "Teslimat Düzenle",
    children: (
      <div style={{ width: "50vw" }}>
        <Stack tokens={{ childrenGap: 10 }}>
          <Text variant="xLarge">Ürün Listesi</Text>
          <ProductList shipmentEditMode />
          <br />
          <Text variant="xLarge">Teslim Zamanı</Text>
          <ShipmentSection />
        </Stack>
      </div>
    ),
  });
};
